export default ({ app }) => {
  app.router.afterEach((to, from) => {
    if (window && window?.dataLayer) {
      window.dataLayer.push({ event: 'optimize.activate' });
    }
    return false;
  });
};
